const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    style: {
      color: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.73698,0,0,0.73698,-10.6157,89.8735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.221,20.313C154.639,20.313 188.086,-22.315 188.086,-35.107C188.086,-47.9 154.639,-90.527 101.221,-90.527C48.682,-90.527 14.404,-47.9 14.404,-35.107C14.404,-22.315 48.682,20.313 101.221,20.313ZM101.318,-2.783C83.35,-2.783 68.75,-17.627 68.701,-35.059C68.701,-53.125 83.35,-67.383 101.318,-67.383C119.238,-67.383 133.838,-53.027 133.838,-35.059C133.838,-17.627 119.238,-2.783 101.318,-2.783ZM101.221,-21.582C108.691,-21.582 114.746,-27.637 114.746,-35.01C114.746,-42.383 108.691,-48.584 101.221,-48.584C93.75,-48.584 87.793,-42.383 87.793,-35.01C87.793,-27.637 93.75,-21.582 101.221,-21.582Z",
    style: {
      color: "currentColor",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a57ddbefe3666e4e50f2ce754cf53c41.svg";
export { ForwardRef as ReactComponent };